import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { PaginatedResult } from 'src/app/models/paginated-result.model';
import { Ticket } from 'src/app/models/ticket/ticket.model';
import { TicketService } from '../../core/services/ticket';
import * as ticketActions from '../actions/tickets.action';

@Injectable()
export class TicketEffects {
  private actions$ = inject(Actions);

  private ticketService = inject(TicketService);

  loadTickets$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ticketActions.LOAD_TICKETS),
      switchMap((action: ticketActions.LoadTickets) => {
        const page = action.payload?.page ?? 0;
        const pageSize = action.payload?.pageSize ?? 9999;
        return this.ticketService.getTickets(page, pageSize).pipe(
          map(
            (res: PaginatedResult<Ticket>) =>
              new ticketActions.LoadTicketsSuccess(res),
          ),
          catchError((error) => of(new ticketActions.LoadTicketsFail(error))),
        );
      }),
    ),
  );
}
